import { z } from "zod";
export const EscalationItem = z.object({
    id: z.string(),
    ruleId: z.string(),
    severity: z.string(),
    persona: z.string().nullable(),
    status: z.string(),
    createdAt: z.string(),
    suggestedAction: z.string(),
});
export const GetEscalationsResponse = z.object({
    rows: z.array(EscalationItem),
});
export const CreateEscalationRequest = z.object({
    note: z.string().optional(),
    memberInitiated: z.boolean().optional(),
});
export const CreateEscalationResponse = z.object({
    created: z.boolean(),
    id: z.string().optional(),
    severity: z.string().optional(),
    status: z.string().optional(),
    reason: z.string().optional(),
});
export const GetOperationsEscalationsQuery = z.object({
    limit: z.string().optional(),
    companyId: z.string().optional(),
});
const LOOSE_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const OperationsEscalationParams = z.object({ id: z.string().regex(LOOSE_UUID_RE) });
/**
 * How an escalation ended. Structured, because the only way to learn whether a
 * screen over-fires is to count outcomes, and counting must never mean matching
 * keywords against a navigator's prose.
 */
export const EscalationResolutionCode = z.enum([
    "supported",
    "no_concern",
    "unreachable",
    "crisis_routed",
    "screen_was_wrong",
]);
/** The two codes that mean the screen fired on someone who was not at risk. */
export const FALSE_ALARM_RESOLUTION_CODES = [
    "no_concern",
    "screen_was_wrong",
];
export const ResolveEscalationRequest = z.object({
    code: EscalationResolutionCode,
    note: z.string().max(500).optional(),
});
export const OperationsEscalationItem = z.object({
    id: z.string(),
    userId: z.string(),
    createdAt: z.string(),
    ruleId: z.string(),
    severity: z.string(),
    persona: z.string().nullable(),
    status: z.string(),
    vendorTicketId: z.string().nullable(),
    /** Who owns it. Null until someone acknowledges. */
    acknowledgedBy: z.string().nullable().default(null),
    acknowledgedByName: z.string().nullable().default(null),
    acknowledgedAt: z.string().nullable().default(null),
});
export const GetOperationsEscalationsResponse = z.object({
    generatedAt: z.string(),
    rows: z.array(OperationsEscalationItem),
});
/** How a detection made during a request reaches the member who made it. */
export const SUPPORT_HEADER = "x-healthos-support";
export const SupportKind = z.enum(["self_harm", "bp_crisis"]);
export const RequestEscalationRequest = z.object({
    note: z.string().optional(),
    memberInitiated: z.boolean().optional(),
});
export const RequestEscalationResponse = z.object({
    created: z.literal(true),
    id: z.string(),
    severity: z.string(),
    status: z.string(),
});
//# sourceMappingURL=escalations.js.map